// In-memory tour state. No persistence, no storage writes.
// One active tour at a time. Subscribers re-render on changes.

export const TOUR_START_EVENT = "roava:tour:start";

export function startTour(tourId: string): void {
  try {
    window.dispatchEvent(new CustomEvent(TOUR_START_EVENT, { detail: { tourId } }));
  } catch { /* noop */ }
}
